import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';
import { FunctionField } from 'components/field'
import { NumberInput, TextInput, BooleanInput, SelectInput } from 'components/input';
import { DisabledInputOptions, InputOptions, RECORD_FORM } from 'util/constants';

import Toolbar from 'components/form/Toolbar';
import { SaveButton } from 'components/button';

import * as urls from './urls';
import * as utils from "./utils";
import {change as changeAction} from "redux-form";


class AppSubscriptionUpdateBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDefaultPrice: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.formInitial !== this.props.formInitial) {
      this.setState({ isDefaultPrice: nextProps.formInitial.price_type === 1});
    }
  }

  handleSubmit = (props, basePath) => (record) => {
    props.crudUpdate(props.resource, '', {
      shop_id: record['shop_id'],
      subscription_required: record['subscription_required'] ? 1 : 0,
      price_type: record['price_type'],
      note: record['note'],
    }, props.data, props.editBackendPath, basePath, "App Subscription Status Updated");
  };

  render() {
    const { formInitial, formValues } = this.props;
    const { isDefaultPrice } = this.state;
    return (
      <Edit
        {...this.props}
        editBackendPath={urls.appSubscriptionUpdateBackendPath}
        updateDataOnMount={false}
        handleSubmit={this.handleSubmit}
      >
        <SimpleForm
          toolbar={(
            <Toolbar>
              <SaveButton 
                disabled={(
                  !!formInitial.subscription_required === !!formValues.subscription_required
                  && formInitial.price_type === formValues.price_type
                )}
              />
            </Toolbar>
          )}
        >
          <NumberInput
            source='shop_id'
            label='Shop ID'
            isRequired={true}
            options={DisabledInputOptions}
          />
          <FunctionField
            label='Shop Name'
            render={(record) => (
              record.shop_name || '-'
            )}
            options={DisabledInputOptions}
          />
          <FunctionField
            label='Expiry Date'
            render={(record) => (
              record.expiry_time || '-'
            )}
            options={DisabledInputOptions}
          />
          <BooleanInput
            source='subscription_required'
            label='Subscription Required'
            options={InputOptions}
          />
          {formValues.subscription_required &&
            <div>
              <BooleanInput
                label='Use Default Price'
                options={InputOptions}
                source='default_price'
                input={{
                  onChange: () => {
                    this.setState({isDefaultPrice: !this.state.isDefaultPrice}, () => {
                      if (!this.state.isDefaultPrice) {
                        if(formInitial.is_sunmi_shop) this.props.change(RECORD_FORM, 'price_type', 2);
                        else this.props.change(RECORD_FORM, 'price_type', 3);
                      } else this.props.change(RECORD_FORM, 'price_type', 1);
                    })
                  },
                  value: this.state.isDefaultPrice,
                }}
              />
            </div>
          }

          {!isDefaultPrice && formValues.subscription_required &&
            <SelectInput
              isRequired={true}
              source='price_type'
              choices={utils.SUBSCRIPTION_CHOISES}
              label=''
            />
          }
          <TextInput
            source='note'
            label='Note'
            isRequired={true}
            options={InputOptions}
          />
        </SimpleForm>
      </Edit>
    );
  }
}

export const AppSubscriptionUpdate = connect(
  (state) => {
    return {
      formValues: ((state.form['record-form'] || {}).values || {}),
      formInitial: ((state.form['record-form'] || {}).initial || {}),
    }
  },
  {
    change: changeAction,
  }
)(AppSubscriptionUpdateBase);



// WEBPACK FOOTER //
// ./src/routes/product/AppSubscriptionUpdate.js